import request from "../../utilities/requests";

const askedKey = (eventId) => `chatSmsPrompted:${eventId}`;

export const smsAlreadyAsked = (eventId) => {
  try {
    return localStorage.getItem(askedKey(eventId)) === "true";
  } catch (e) {
    return false;
  }
};

export const rememberSmsAsked = (eventId) => {
  try {
    localStorage.setItem(askedKey(eventId), "true");
  } catch (e) {
    return;
  }
};

export const setSmsEnabled = (enabled) =>
  request("profile/sms", "post", { enabled });
